import {equals, sort, ascend, identity} from "ramda";

export const areUnorderedArraysEqual = (arr1: any[], arr2: any[]): boolean => {
  return equals(sort(ascend(identity), arr1), sort(ascend(identity), arr2));
};
